import { I18nComponente } from "@/types/gerais"

export const OTabelaTiposDeAtividadei18n: I18nComponente = {
  "pt-BR": {
    criarTipoDeAtividade: "criar tipo de atividade",
    nome: "nome",
    codigo: "código",
    pesquisarPorNome: "pesquisar por nome",
    pesquisarPorCodigo: "pesquisar por código",
    duracaoPadrao: "duração padrão",
    limpar: "Limpar",
    aplicar: "Aplicar",
    editar: "editar",
    excluir: "excluir",
    arquivar: "arquivar",
    desarquivar: "desarquivar",
    nao: "não",
    simExcluir: "sim, excluir",
    simArquivar: "sim, arquivar",
    simDesarquivar: "sim, desarquivar",
    horas: "horas",
    minutos: "minutos",
    e: "e",
    atributosEsperados: "atributos esperados",
    aoExcluirTipoDeAtividadeSeraRemovidoDoSistemaPermanentemente: "Ao excluir, o tipo de atividade será removido do sistema permanentemente e não será possível recuperá-lo.",
    aoArquivarTipoDeAtividadeSeraOcultado: "Ao arquivar, não será mais possível criar atividades desse tipo. Será preciso desarquivar o tipo de atividade ao final da listagem dos tipos de atividade.",
    aoDesarquivarTipoDeAtividadeSeraExibido: "Ao desarquivar, o tipo de atividade poderá ser exibido novamente na lista de tipos de atividade ativos.",
    erroAoExcluirTipoDeAtividade: "Erro ao excluir tipo de atividade",
    ocorreuUmErroAoExcluirTipoDeAtividade: "Ocorreu um erro ao excluir o tipo de atividade, tente novamente mais tarde.",
    erroAoArquivarTipoDeAtividade: "Erro ao arquivar tipo de atividade",
    ocorreuUmErroAoArquivarTipoDeAtividade: "Ocorreu um erro ao arquivar o tipo de atividade, tente novamente mais tarde.",
    erroAoDesarquivarTipoDeAtividade: "Erro ao desarquivar tipo de atividade",
    ocorreuUmErroAoDesarquivarTipoDeAtividade: "Ocorreu um erro ao desarquivar o tipo de atividade, tente novamente mais tarde."
  },
  "es-CO": {
    criarTipoDeAtividade: "añadir tipo de actividad",
    nome: "nombre",
    codigo: "código",
    pesquisarPorNome: "buscar por nombre",
    pesquisarPorCodigo: "buscar por código",
    duracaoPadrao: "duración predeterminada",
    limpar: "Borrar",
    aplicar: "Aplicar",
    editar: "editar",
    excluir: "borrar",
    arquivar: "archivar",
    desarquivar: "desarchivar",
    nao: "no",
    simExcluir: "sí, borrar",
    simArquivar: "sí, archivar",
    simDesarquivar: "sí, desarchivar",
    horas: "horas",
    minutos: "minutos",
    e: "y",
    atributosEsperados: "atributos esperados",
    aoExcluirTipoDeAtividadeSeraRemovidoDoSistemaPermanentemente: "al borrar, el tipo de actividad se eliminará del sistema permanentemente y no se podrá recuperar.",
    aoArquivarTipoDeAtividadeSeraOcultado: "al archivar, el tipo de actividad se ocultará y ya no aparecerá en la lista de tipos de actividad activos.",
    aoDesarquivarTipoDeAtividadeSeraExibido: "al desarchivar, el tipo de actividad se mostrará nuevamente en la lista de tipos de actividad activos.",
    erroAoExcluirTipoDeAtividade: "Error al borrar tipo de actividad",
    ocorreuUmErroAoExcluirTipoDeAtividade: "Ocurrió un error al borrar el tipo de actividad, inténtelo de nuevo más tarde.",
    erroAoArquivarTipoDeAtividade: "Error al archivar tipo de actividad",
    ocorreuUmErroAoArquivarTipoDeAtividade: "Ocurrió un error al archivar el tipo de actividad, inténtelo de nuevo más tarde.",
    erroAoDesarquivarTipoDeAtividade: "Error al desarchivar tipo de actividad",
    ocorreuUmErroAoDesarquivarTipoDeAtividade: "Ocurrió un error al desarchivar el tipo de actividad, inténtelo de nuevo más tarde."
  }
}
